module.exports = __webpack_public_path__ + "img/memory.9f1f6e9e.svg";